module.exports = __webpack_public_path__ + "static/media/demand.866a02ef.svg";